module.exports = __webpack_public_path__ + "static/media/bg-hero.bdcafbbd.webp";